const DEFAULT_BYPASS_COOKIE_NAME: string = 'Authenticated'

export const useBypassCookieName = (): string => {
  const config = useRuntimeConfig()

  return config.public.bypassCookieName || DEFAULT_BYPASS_COOKIE_NAME
}
